import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { OrganizationKeyName } from "../../model/Organization";
import { RootState } from "../../store";
import { routes } from "../../appRoutingHelpers";
import { EmailTemplateItem } from "../../model/EmailTemplateItem";
import { TableRow } from "../../components/table-components/TableRow";
import { colors } from "../../components/colors";
import { StyledText } from "../../assets/typography/typography";
import { TableCellLink } from "../../components/table-components/TableCellLink";

interface OwnProps {
  organization: OrganizationKeyName;
  emailTemplate: EmailTemplateItem;
}

interface Props extends OwnProps {}

interface State {}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  return {
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {};
};

class EmailTemplateListRow extends React.Component<Props, State> {
  render() {
    const emailTemplate = this.props.emailTemplate;
    const org = this.props.organization;
    const href = routes.emailTemplateEdit(org, emailTemplate.id);

    return (
      <TableRow>
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {emailTemplate.templateName}
          </StyledText>
        </TableCellLink>
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {emailTemplate.replyToAddress}
          </StyledText>
        </TableCellLink>
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {emailTemplate.replyToName}
          </StyledText>
        </TableCellLink>
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {emailTemplate.subject}
          </StyledText>
        </TableCellLink>
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {emailTemplate.fromAddress}
          </StyledText>
        </TableCellLink>
      </TableRow>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailTemplateListRow);
